import { render } from "./StageActorView.vue?vue&type=template&id=6d973385"
import script from "./StageActorView.vue?vue&type=script&lang=js"
export * from "./StageActorView.vue?vue&type=script&lang=js"

import "./StageActorView.vue?vue&type=style&index=0&id=6d973385&lang=scss"
script.render = render

export default script